import React from 'react';
import InitialLogo from './assets/initial-remake.js';

const Logo = () => {
    return <div className="Logo">{InitialLogo}</div>;
};

export default Logo;
